module.exports = __webpack_public_path__ + "static/publish_395x275-dc09cfe666f391d922e841701c8042b8.png";